import { useAuth } from '@/context/AuthContext';
import { useImpersonation } from '@/hooks/useImpersonation';

const ImpersonationBanner = () => {
  const { user } = useAuth();

  const { isAdmin, exitImpersonation } = useImpersonation();

  if (!user || !isAdmin) return null;

  return (
    <div className="left-0 top-0 sticky w-full justify-center gap-2 text-center h-9 text-destructive-solid text-sm font-semibold bg-destructive p-2 z-[49] flex items-center">
      <span>Impersonating user: {user?.email}</span>
      <button
        onClick={exitImpersonation}
        className="bg-transparent border-none underline cursor-pointer "
      >
        Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
